export default __webpack_public_path__ + "static/media/branding-bg.23719708.jpg";